import React from 'react';

import Text from 'relements/build/esm/input/text';
import Dropdown from 'relements/build/esm/input/dropdown';

const GENERAL_SETTINGS = {
  title: 'General Settings',
  inputs: [
    {
      label: 'Business Name',
      key: 'businessName',
      component: Text,
    },
    {
      label: 'Business Via Name',
      key: 'businessViaName',
      component: Text,
      props: (value, onChange, form, meta) => ({
        value:
          meta.isNew && form.businessName
            ? `${form.businessName
                .toLowerCase()
                .replace(/[^a-z0-9]/g, '')}channel`
            : form.businessViaName,
        tooltip:
          'Hint: For multilanguage bots the name must end in _code (Ex. mybotchannel_en for english)',
      }),
    },
    {
      label: 'Preview Text',
      key: 'previewText',
      component: Text,
    },
    {
      label: 'Order',
      key: 'order',
      className: 'order-field',
      component: Text,
      props: (value, onChange, form, meta) => ({
        onChange: order => onChange(order ? parseInt(order, 10) : ''),
      }),
    },
    {
      label: 'Account',
      key: 'activePartners',
      component: Dropdown,
      props: (value, onChange, form, meta) => ({
        options: meta.allPartners,
        optionKey: 'value',
        searchKeys: ['value'],
        withSearch: true,
        // onChange: option => onChange([option]),
        disabled: true,
      }),
    },
    {
      label: 'Default Team',
      key: 'defaultTeam',
      component: Dropdown,
      prodEdit: true,
      permission: 'mogambo_business_team_edit',
      props: (value, onChange, form, meta) => ({
        withSearch: true,
        options: meta.allTeams.map(team => ({
          label: team.name,
          value: team.name,
        })),
        optionKey: 'label',
        invisible: meta.isNew,
      }),
    },
    {
      label: 'Language',
      key: 'languageCode',
      component: Dropdown,
      props: (value, onChange, form, meta) => ({
        withSearch: true,
        options: meta.allLanguages.map(language => ({
          label: language.name,
          value: language.code,
        })),
        optionKey: 'label',
        tooltip:
          'Hint: To create a multiple language bot, duplicate this business and change the business via name pattern',
      }),
    },
  ],
};

export default GENERAL_SETTINGS;
